import { Controller } from "stimulus"
export default class extends Controller {
  static get targets(){
    return ['source'];
  }



  copy(e){
    e.preventDefault()
    if (this.sourceTarget.nodeName != 'INPUT') { 
      var node = document.createElement('input'); 
      node.value = this.sourceTarget.innerText;
      this.sourceTarget.append(node); 
      node.focus();
      node.select();
    }
    else { 
      this.sourceTarget.select();
    }
    if (this.data.get('hidden-source')) {
      navigator.clipboard.writeText(this.sourceTarget.value)
      let clone = e.target.cloneNode(true); 
      clone.innerText = 'Copied!'
      e.target.parentNode.appendChild(clone); 
      clone.classList.add('copy-message'); 
      clone.addEventListener('transitionend', function(e) {
        clone.remove()
      })
      setTimeout(function() { clone.classList.add('copied-message') }, 200 )

    }
    else {
      document.execCommand("copy")
    }
    if (node){
      node.remove();
    }

  }

}
